import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue';
import LoginPage from '../views/LoginPage.vue';
import ChangePasswordPage from '../views/ChangePasswordPage.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: LoginPage
  },
  {
    path: '/changePass',
    component: ChangePasswordPage
  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: '/tabs/master'
      },
      {
        path: 'master',
        component: () => import('@/views/MasterPage.vue')
      },
      {
        path: 'metrica',
        component: () => import('@/views/MedidasPage.vue')
      },
      {
        path: 'instantanea',
        component: () => import('@/views/InstantaneaPage.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
